import { Weekday } from 'hevy-shared';

export const weekdayNumberMap: { [key in Weekday]: number } = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

/**
 * compare two nullable optional strings, treating `null`,
 * `undefined` and the empty string as the same value
 */
export const nullableStringsEqual = (
  nullableA: string | null | undefined,
  nullableB: string | null | undefined,
): boolean => {
  const stringA = nullableA ? nullableA : '';
  const stringB = nullableB ? nullableB : '';

  return stringA === stringB;
};
